import React from 'react'
import { PersonData } from '../../../../types/api'
import { A } from '../../../atoms/A'
import { LineClampText } from '../../../atoms/LineClampText'
import { Table, TableCell, TableHeading } from '../../../atoms/Table'
import { EmptyCard } from '../../../common/EmptyCard'
import { CardInnerTitle } from '../../../atoms/CardInnerTitle'
import { Card, mq } from 'plume-ui'
import { LimitedToEnterpriseContents } from '../../../common/LimitedToEnterpriseContents'
import { css } from '@emotion/react'

type Props = {
  title: string
  directors: PersonData[]
  isEnterprise: boolean
}

export const DirectorsTable: React.FC<Props> = (props) => {
  if (!props.isEnterprise) {
    return (
      <Card>
        <CardInnerTitle title={props.title} />
        <Table>
          <thead
            css={css`
              ${mq.untilMedium} {
                display: ${props.isEnterprise ? 'initial' : 'none'};
              }
            `}
          >
            <tr>
              <TableHeading>名前</TableHeading>
              <TableHeading>役職</TableHeading>
              <TableHeading>職名</TableHeading>
              <TableHeading>略歴</TableHeading>
              <TableHeading>出所</TableHeading>
            </tr>
          </thead>
          <tbody
            css={css`
              ${mq.untilMedium} {
                display: flex;
                justify-content: center;
              }
            `}
          >
            <tr>
              <TableCell colSpan={5} align="center">
                <LimitedToEnterpriseContents />
              </TableCell>
            </tr>
          </tbody>
        </Table>
      </Card>
    )
  }

  if (props.directors.length === 0) {
    return <EmptyCard />
  }

  return (
    <Card>
      <CardInnerTitle title={props.title} />
      <Table>
        <thead>
          <tr>
            <TableHeading>名前</TableHeading>
            <TableHeading>役職</TableHeading>
            <TableHeading>職名</TableHeading>
            <TableHeading>略歴</TableHeading>
            <TableHeading>出所</TableHeading>
          </tr>
        </thead>
        <tbody>
          {props.directors.map((d, i) => (
            <tr key={i}>
              <TableCell nowrap>
                <A href={d.path} decoration="none">
                  {d.name}
                </A>
              </TableCell>
              <TableCell nowrap>{d.title}</TableCell>
              <TableCell nowrap>{d.jobTitle}</TableCell>
              <TableCell>
                <LineClampText lineNumber={3}>{d.bio}</LineClampText>
              </TableCell>
              <TableCell nowrap>{d.sourceSite}</TableCell>
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  )
}
